export default __webpack_public_path__ + "static/media/musashi-avatar-medium.3dde246f.png";